import cookie from 'js-cookie';
import set from 'lodash/set';

var format = function format(key) {
  return "https://".concat(key, ".appsync-api.us-east-1.amazonaws.com/graphql");
};

export var myapUrls = {
  local: format('v5jyvjuogzhwxnsjzawzluwqhm'),
  dev: format('v5jyvjuogzhwxnsjzawzluwqhm'),
  amdev: format('gmuoyaundfbvphhztft2i2qmdm'),
  qa: format('62rox5gy5fhtllqgs47rx75l2a'),
  qa2: format('pz4rpawpaffvbdndcl3ssj2z2y'),
  uat: format('2p7h6hkmsrhb3mf6gl5sjalpui'),
  oat: format('sk4q3nntynh5pgjqbkbq2jva34'),
  dte: format('id2btfgsobhqpk2depyrtcknum'),
  prod: format('dgtkl2ep7natjmkbefhxflglie'),
  perf: format('2auboyi5zff2bhipbgtv7ozmu4'),
  releasedev: format('k625k2vrzvdo5g7ynbvtjejehi')
};
export var classroomUrls = {
  uat: 'https://apclassroom-uat.collegeboard.org',
  amdev: 'https://apclassroom-testing.collegeboard.org',
  pentest: 'https://p2-apclassroom-content.collegeboard.org',
  perf: 'https://apclassroom-perf.collegeboard.org'
};
export var apcentralUrls = {
  prod: 'https://apcentral.collegeboard.org',
  uat: 'https://apcentral-preview.cms-sites.collegeboard.org',
  oat: 'https://apcentral-preview.cms-sites.collegeboard.org',
  dte: 'https://apcentral-preview.cms-sites.collegeboard.org',
  perf: 'https://apcentral-preview.cms-sites.collegeboard.org',
  amdev: 'https://apcentral-preview.cms-sites.collegeboard.org'
};
export var apstudentsUrls = {
  prod: 'https://apstudents.collegeboard.org',
  uat: 'https://apstudents-stg.collegeboard.org',
  oat: 'https://apstudents-stg.collegeboard.org',
  dte: 'https://apstudents-stg.collegeboard.org',
  perf: 'https://apstudents-stg.collegeboard.org',
  amdev: 'https://apstudents-stg.collegeboard.org'
};
export var digitalAppUrls = {
  prod: 'https://download.app.collegeboard.org',
  perf: 'https://launch-int.stp-nonprod.collegeboard.org'
}; // defaults mapping between collegeboard environments to apfym environments

export var CB_MAP = {
  oak: 'dev',
  palm: 'releasedev',
  apple: 'uat',
  maple: 'oat',
  spruce: 'perf'
};
export var APFYM_MAP = {
  dev: 'oak',
  qa: 'palm',
  qa2: 'palm',
  qaint: 'palm',
  uat: 'apple',
  oat: 'maple',
  amdev: 'palm',
  perf: 'spruce',
  releasedev: 'palm',
  dte: 'palm',
  pentest: 'palm'
};
export var getEnvironmentVariables = function getEnvironmentVariables(env) {
  var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 366;
  var lowerEnv = cookie.get('lower_Env');
  var apfymEnv = env === 'local' ? 'dev' : env || CB_MAP[lowerEnv] || 'prod';
  var cbEnv = lowerEnv || APFYM_MAP[env];
  var isProd = apfymEnv === 'prod';
  var isLocal = env === 'local';
  return {
    classroomUrl: classroomUrls[apfymEnv] || 'https://apclassroom.collegeboard.org',
    aproUrl: isLocal ? 'https://apfym.collegeboard.org:3000' : isProd ? 'https://myap.collegeboard.org' : "https://".concat(apfymEnv, ".apfym-nonprod.collegeboard.org"),
    myapUrl: isLocal ? myapUrls.local : myapUrls[apfymEnv],
    apiUrl: isProd ? 'https://apro-api.collegeboard.org/apfym-app' : "https://api-".concat(apfymEnv, ".apfym-nonprod.collegeboard.org/apfym-app"),
    apiGateUrl: isProd ? 'https://apfym-api.collegeboard.org/prod' : "https://api-nonprod.apfym-nonprod.collegeboard.org/".concat(apfymEnv),
    orgcdsConfig: {
      url: isProd ? 'https://organization.cds-prod.collegeboard.org/pine' : "https://organization.cds-nonprod.collegeboard.org/".concat(cbEnv),
      apiKey: isProd ? 'GFWwItx5Vj427rA72GAvx8orEBnt0b7n9uMPeYVY' : 'FY2IO65gu57QRF1mj4Sr6CV2CAjCW578StWoEs2g'
    },
    appId: appId,
    apcentralUrl: apcentralUrls[apfymEnv] || 'https://apcentral-dev.collegeboard.org',
    apstudentsUrl: apstudentsUrls[apfymEnv] || 'https://apstudents-dev.collegeboard.org',
    studentPracticeBucketName: "org-collegeboard-apfym-myap-student-practice-results-".concat(apfymEnv),
    studentDigitalAppUrl: isProd ? 'https://download.app.collegeboard.org' : 'https://launch-int.stp-nonprod.collegeboard.org/'
  };
};
export var setEnvironment = function setEnvironment(env) {
  var appId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 366;
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'myap.profile';
  return set(window, namespace, getEnvironmentVariables(env, appId));
};